export const StripePublishableKey ='pk_live_51IB6IKLyk5Nn4cKQL1gEooOAjbNIKK9FJcLl8bkEI7KWrASvwlLshqCazDXjiFA593vfGdkagszqCmRAW1GS4CdC00Ywd5NlLA';
// export const StripePublishableKey ='pk_test_51IB6IKLyk5Nn4cKQwME2pqFGI3zC87czHknD47V2dqWZwyAN3PAZmZ2z2rJdDAbeM4AYVYjnnrF2TojKlnJ5fvcl00gNr26xXg';

